import styled from "styled-components";
import { GrayColors, SolutionColorVariables } from "@smartsuite/types";

export const StyledInfoButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35px;
  height: 35px;
  border-radius: 5px;
  background-color: ${GrayColors["G-1"]};
  cursor: pointer;
  transition: background-color 200ms ease-in;
  color: ${SolutionColorVariables.sc1};

  &:hover {
    color: ${SolutionColorVariables.sc3};
  }
`;
